export default __webpack_public_path__ + "asset/img/icon-leave~c5b03b70.png";